import { UpdateOrderItemPage } from './UpdateOrderItemPage';
import { AddOrderItemPage } from './AddOrderItemPage';

export class OrderItemPage {
	constructor( element ) {
		this.element = element;

		const urlParams = new URLSearchParams( window.location.search );

		this.orderId = urlParams.get( 'order_id' );
		this.itemId = urlParams.get( 'item_id' );

		this.cartForm = this.element.querySelector( 'form.cart' );
		this.isRetailer = this.element.classList.contains( 'qala-b2b-retailer' );
		this.isAdmin = this.element.classList.contains( 'admin-bar' );
	}

	init() {
		if ( this.orderId && this.itemId ) {
			const updateOrderItemPage = new UpdateOrderItemPage( this.element, this.orderId, this.itemId );
			updateOrderItemPage.init();
		}

		if ( this.cartForm && ( this.isRetailer || this.isAdmin ) ) {
			const addOrderItemPage = new AddOrderItemPage( this.element );
			addOrderItemPage.init();
		}
	}
}
